import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../../services/shared.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-page-not-found',
    imports: [],
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent {
  private _sharedService = inject(SharedService);
}
